import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const missedRevenueAnalysisSlice = createApi({
  reducerPath: "analysis_missed_revenue",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["missed_revenue"],
  endpoints: (build) => ({
    getMissedRevenueSummary: build.query({
      query: ({ orgId, headers, payload }) => ({
        // url: `bank/${orgId}/dashboard?card=missed_revenue&view=summary&page=0&size=10`,
        url: `/bank/${orgId}/dashboard/${payload.requid}/missed_revenue/summary`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),

    getMissedRevenueExpanded: build.query({
      query: ({ orgId, headers, payload }) => ({
        // url: `bank/${orgId}/dashboard?card=missed_revenue&view=expand&page=0&size=10`,
        url: `/bank/${orgId}/dashboard/${payload.requid}/missed_revenue/expand`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetMissedRevenueSummaryQuery,
  useGetMissedRevenueExpandedQuery,
} = missedRevenueAnalysisSlice;
